<template>
  <div>
    <Head title="Payout Locations" />
    <h1 class="mb-8 text-3xl font-bold">Payout Locations</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">MyNafa Agents:</label>
        <select v-model="form.my_nafa" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="only">MyNafa Agents</option>
          <option value="except">Partner Agents</option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6">Location</th>
            <th class="pb-4 pt-6 px-6">Address</th>
            <th class="pb-4 pt-6 px-6">Contact</th>
            <th class="pb-4 pt-6 px-6">MyNafa Agent</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="payout in payouts.data" :key="payout.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
                {{ payout.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" tabindex="-1">
                {{ payout.location }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" tabindex="-1">
                {{ payout.address }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" tabindex="-1">
                {{ payout.contact }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" tabindex="-1">
                {{ payout.is_mynafa_agent == 'yes' ? 'Yes' : 'No' }}
              </Link>
            </td>
          </tr>
          <tr v-if="payouts.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">No Payout Locations found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-4" :links="payouts.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    payouts: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        my_nafa: this.filters.my_nafa,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/agencies/payouts/', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
